var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.15,
    height: 20.15,
    viewBox: "0 0 20.15 20.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24045",
    "data-name": "Group 24045",
    transform: "translate(-14.925 -14.925)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_342035",
    "data-name": "Path 342035",
    d: "M33.5,25.925h-6A1.577,1.577,0,0,0,25.925,27.5v6A1.577,1.577,0,0,0,27.5,35.075h6A1.577,1.577,0,0,0,35.075,33.5v-6A1.577,1.577,0,0,0,33.5,25.925Zm.425,7.575a.426.426,0,0,1-.425.425h-6a.426.426,0,0,1-.425-.425v-6a.426.426,0,0,1,.425-.425h6a.426.426,0,0,1,.425.425Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_342036",
    "data-name": "Path 342036",
    d: "M27.075,21.5v-5A1.577,1.577,0,0,0,25.5,14.925h-9A1.577,1.577,0,0,0,14.925,16.5v5A1.577,1.577,0,0,0,16.5,23.075h9A1.577,1.577,0,0,0,27.075,21.5Zm-1.15,0a.426.426,0,0,1-.425.425h-9a.426.426,0,0,1-.425-.425v-5a.426.426,0,0,1,.425-.425h9a.426.426,0,0,1,.425.425Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_342037",
    "data-name": "Path 342037",
    d: "M23.5,30.925A2.428,2.428,0,0,1,21.075,28.5V26.782l1.071,1.072a.5.5,0,0,0,.708-.708l-2-2a.5.5,0,0,0-.708,0l-2,2a.5.5,0,0,0,.708.708l1.071-1.072V28.5A3.579,3.579,0,0,0,23.5,32.075a.575.575,0,1,0,0-1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_342038",
    "data-name": "Path 342038",
    d: "M29.5,18.075A2.428,2.428,0,0,1,31.925,20.5v1.718l-1.071-1.072a.5.5,0,0,0-.708.708l2,2a.5.5,0,0,0,.708,0l2-2a.5.5,0,0,0-.708-.708l-1.071,1.072V20.5A3.579,3.579,0,0,0,29.5,16.925a.575.575,0,0,0,0,1.15Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon);
export default __webpack_public_path__ + "static/media/sort_icon.ed533c4793deddb247f678e227b8f90d.svg";
export { ForwardRef as ReactComponent };